import ChipInput from 'material-ui-chip-input';

export default ChipInput;
